import { render, staticRenderFns } from "./TodoTemplateForm.vue?vue&type=template&id=30fef97f&"
import script from "./TodoTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TodoTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports